import React, { useState } from 'react';

const Header: React.FC = () => {
  const [isMobileNavExpanded, setMobileNavExpanded] = useState(false);

  const toggleMobileNav = (e: React.MouseEvent) => {
    e.preventDefault();
    setMobileNavExpanded(!isMobileNavExpanded);
  };

  return (
    <>
        <header className="main-header clearfix">
          <div className="main-header__top">
            <div className="main-header__top-inner" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: '45px' }}>
              <div style={{ flex: '1' }}></div>
              <div className="main-header__top-address" style={{ flex: '0 0 auto' }}>
                <a href="/"><img src="/assets/images/resources/Logo-VyL-Asociados-Horizontal.png" alt=""
                  style={{ width: '350px', height: 'auto' }} /></a>
              </div>
              <ul className="main-menu__list" style={{ display: 'flex', alignItems: 'center', listStyle: 'none', margin: '0', padding: '0', flex: '0 0 auto', gap: '25px' }}>
                  <li className="dropdown current megamenu" style={{ margin: '0 20px' }}>
                    <a 
                      href="/" 
                      style={{ 
                        textDecoration: 'none', 
                        color: '#000000', 
                        transition: 'color 0.3s ease',
                        fontFamily: 'Axiforma-Bold, sans-serif'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = '#039ecd';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = '#000000';
                      }}
                    >
                      INICIO
                    </a>
                  </li>
                  <li style={{ margin: '0 20px' }}>
                    <a 
                      href="/about" 
                      style={{ 
                        textDecoration: 'none', 
                        color: '#000000', 
                        transition: 'color 0.3s ease',
                        fontFamily: 'Axiforma-Bold, sans-serif'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = '#039ecd';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = '#000000';
                      }}
                    >
                      NOSOTROS
                    </a>
                  </li>
                  <li className="dropdown" style={{ margin: '0 20px' }}>
                    <a 
                      href="/solutions" 
                      style={{ 
                        textDecoration: 'none', 
                        color: '#000000', 
                        transition: 'color 0.3s ease',
                        fontFamily: 'Axiforma-Bold, sans-serif'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = '#039ecd';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = '#000000';
                      }}
                    >
                      SOLUCIONES
                    </a>
                  </li>
                </ul>
              <div className="main-menu__btn-box" style={{ flex: '0 0 auto' }}>
                <a 
                  href="#newsletter-section" 
                  className="thm-btn main-menu__btn" 
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.getElementById('newsletter-section');
                    if (element) {
                      element.scrollIntoView({ 
                        behavior: 'smooth',
                        block: 'start'
                      });
                    }
                  }}
                >
                  <img src="/assets/images/resources/Ícono-botón-contacto.png" alt="Contacto" style={{ width: '20px', height: '20px' }} />
                  CONTACTO
                </a>
              </div>
              <div style={{ flex: '1' }}></div>
            </div>
          </div>
          <nav className="main-menu clearfix">
            <div className="main-menu__wrapper clearfix">
              <div className="main-menu__wrapper-inner clearfix">
                <div className="mobile-logo__toggler">
                <a href="/"><img src="/assets/images/resources/Logo-VyL-Asociados-Horizontal.png" alt=""
                  className="logoMain" /></a>
                </div>
                <div className="main-menu__left">
                  <div className="main-menu__main-menu-box">
                    <a href="#" className="mobile-nav__toggler" onClick={toggleMobileNav}><i className="fa fa-bars"></i></a>
                  </div>

                </div>
              </div>
            </div>
          </nav>
        </header>

        <div className={`mobile-nav__wrapper  ${isMobileNavExpanded ? 'expanded' : ''}`}>
        <div className="mobile-nav__overlay mobile-nav__toggler"></div>
        <div className="mobile-nav__content">
            <span className="mobile-nav__close mobile-nav__toggler" onClick={toggleMobileNav}><i className="fa fa-times"></i></span>

            <div className="logo-box">
                <a href="index.html" aria-label="logo image"><img src="/assets/images/resources/Logo-VyL-white-Asociados-Horizontal.png" width="143"
                        alt="" /></a>
            </div>
           
            <div className="mobile-nav__container">

            <ul className="main-menu__list">
                      <li className="dropdown current megamenu">
                        <a href="/">INICIO </a>
                      </li>
                      <li>
                        <a href="/about">NOSOTROS</a>
                      </li>
                      <li className="dropdown">
                        <a href="/solutions">SOLUCIONES</a>
                      </li>
                    </ul>

            </div>
            

            <ul className="mobile-nav__contact list-unstyled">
                <li>
                    <i className="fa fa-envelope"></i>
                    <a href="mailto:fatima.giron@vyl-asociados.com">fatima.giron@vyl-asociados.com</a>
                </li>
                <li>
                    <i className="fa fa-phone-alt"></i>
                    <a href="tel:+51915249836">+51 915249836</a>
                </li>
            </ul>
            { /*<div className="mobile-nav__top">
                <div className="mobile-nav__social">
                <a href="https://www.facebook.com/profile.php?id=100088485326446" target='_blank'><i className="fab fa-facebook"></i></a>
                <a href="https://www.linkedin.com/company/91704465/admin/feed/posts/"  target='_blank'><i className="fab fa-linkedin"></i></a>
                </div>
            </div> */}
        </div>
    </div>
    </>
  );
};

export default Header;